import { LoadState } from 'app/core/interfaces/generic.interface';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { CustomerPermissions } from 'app/core/store/session/customer-permissions/customer-permissions.interface';
import { INITIAL_STATE_CUSTOMER_PERMISSIONS } from 'app/core/store/session/customer-permissions/customer-permissions.model';
import * as actions from './customer-permissions.actions';

function customerPermissionsLoad(action: actions.CustomerPermissionsLoadAction, state: LoadState<CustomerPermissions>): LoadState<CustomerPermissions> {
  return {
    ...INITIAL_STATE_CUSTOMER_PERMISSIONS,
    loading: true,
  };
}

function mapIdToObject<T extends Definition>(id: string, objects: T[]): T {
  return objects.find(c => c.id === id);
}

function mapIdsToObjects<T extends Definition>(ids: string[], objects: T[]): T[] {
  return ids.map(id => mapIdToObject(id, objects));
}

function customerPermissionsLoadSuccess(action: actions.CustomerPermissionsLoadSuccessAction, state: LoadState<CustomerPermissions>): LoadState<CustomerPermissions> {
  return {
    ...INITIAL_STATE_CUSTOMER_PERMISSIONS,
    loadSuccess: true,
    data: {
      blankReceipts: mapIdsToObjects(action.payload.customerPermissions.blankReceipts, action.payload.customers),
      createOrUpdateFlow: mapIdsToObjects(action.payload.customerPermissions.createOrUpdateFlow, action.payload.customers),
      createOrUpdateOrder: mapIdsToObjects(action.payload.customerPermissions.createOrUpdateOrder, action.payload.customers),
      invoices: mapIdsToObjects(action.payload.customerPermissions.invoices, action.payload.customers),
      queryOrGetFlow: mapIdsToObjects(action.payload.customerPermissions.queryOrGetFlow, action.payload.customers),
      queryOrGetOrder: mapIdsToObjects(action.payload.customerPermissions.queryOrGetOrder, action.payload.customers),
      calenderLegend: mapIdsToObjects(action.payload.customerPermissions.calenderLegend, action.payload.customers),
      acceptFlow: mapIdsToObjects(action.payload.customerPermissions.acceptFlow, action.payload.customers),
    },
  };
}

function customerPermissionsLoadFail(action: actions.CustomerPermissionsLoadFailAction, state: LoadState<CustomerPermissions>): LoadState<CustomerPermissions> {
  return {
    ...INITIAL_STATE_CUSTOMER_PERMISSIONS,
    loadFailed: true,
  };
}

export function reducer(state = INITIAL_STATE_CUSTOMER_PERMISSIONS, action: actions.Actions): LoadState<CustomerPermissions> {
  let newState = state;
  switch (action.type) {
    case actions.CUSTOMER_PERMISSIONS_LOAD:
      newState = customerPermissionsLoad(action, state);
      break;
    case actions.CUSTOMER_PERMISSIONS_LOAD_SUCCESS:
      newState = customerPermissionsLoadSuccess(action, state);
      break;
    case actions.CUSTOMER_PERMISSIONS_LOAD_FAIL:
      newState = customerPermissionsLoadFail(action, state);
      break;
  }
  return newState;
}
